import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiBaseResponseDto, ApiEmptyResponseDto } from '../common-dtos';
import {
  ImConferenceCreateRequestDto,
  ImConferenceDto,
  ImConferenceMemberDto,
  ImConferenceUpdateRequestDto,
} from './dtos';

@Injectable({ providedIn: 'root' })
export class ImConferenceApiService {
  constructor(private readonly http: HttpClient) {}

  public createConference(request: ImConferenceCreateRequestDto): Observable<ImConferenceDto> {
    return this.http
      .post<ApiBaseResponseDto<ImConferenceDto>>('/bvcsp/v1/imgroup/conference/create', request)
      .pipe(map((response) => response.data!));
  }

  public updateConference(groupId: string, request: ImConferenceUpdateRequestDto): Observable<ImConferenceDto> {
    return this.http
      .put<ApiBaseResponseDto<ImConferenceDto>>(`/bvcsp/v1/imgroup/conference/${groupId}`, request)
      .pipe(map((response) => response.data!));
  }

  public deleteConference(groupId: string): Observable<ApiEmptyResponseDto> {
    return this.http.delete<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/${groupId}`);
  }

  public getConference(groupId: string): Observable<ImConferenceDto | null> {
    return this.http
      .get<ApiBaseResponseDto<ImConferenceDto>>(`/bvcsp/v1/imgroup/conference/info/${groupId}`)
      .pipe(map((response) => response.data ?? null));
  }

  public getConferenceMembers(groupId: string): Observable<ImConferenceMemberDto[]> {
    return this.http
      .get<ApiBaseResponseDto<ImConferenceMemberDto[]>>(`/bvcsp/v1/imgroup/conference/members/${groupId}`)
      .pipe(map((response) => response.data ?? []));
  }

  public getConferenceMember(groupId: string, memberId: string): Observable<ImConferenceMemberDto | null> {
    return this.http
      .get<ApiBaseResponseDto<ImConferenceMemberDto>>(`/bvcsp/v1/imgroup/conference/member/info/${groupId}/${memberId}`)
      .pipe(map((response) => response.data ?? null));
  }

  public joinConference(groupId: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/join/apply/${groupId}`, {});
  }

  public quitConference(groupId: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/quit/${groupId}`, {});
  }

  public invite(groupId: string, memberID = ''): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/join/invite/${groupId}`, { memberID });
  }

  public kickOut(groupId: string, memberID: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/kickout/${groupId}`, { memberID });
  }

  public startSpeak(groupId: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/speak/apply/${groupId}`, {});
  }

  public endSpeak(groupId: string, memberID?: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/speak/end/${groupId}`, { memberID });
  }

  public appointSpeak(groupId: string, memberID: string): Observable<ApiEmptyResponseDto> {
    return this.http.post<ApiEmptyResponseDto>(`/bvcsp/v1/imgroup/conference/speak/appoint/${groupId}`, { memberID });
  }
}
